import { gql } from "apollo-boost"

export const getEquipmentAttachmentBySubmissionId = gql`
  query getEquipmentAttachmentBySubmissionId($id: ID!) {
    EquipmentAttachmentsBySubmissionID(submissionID: $id) {
      id
      description
      quantity
      identifier
      isBlocked
      concept {
        id
        name
      }
      documents {
        id
        name
        type
        url
      }
    }
  }
`